import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ramadan2022-footer',
  templateUrl: './ramadan2022-footer.component.html',
  styleUrls: ['./ramadan2022-footer.component.scss']
})
export class Ramadan2022FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
